// extracted by mini-css-extract-plugin
export default {"BreadcrumbContainer":"breadcrumb_BreadcrumbContainer__Cb4Og","Breadcrumb":"breadcrumb_Breadcrumb__Xbmr7","CurrentPage":"breadcrumb_CurrentPage__31dPF"};